import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2e13a520"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "login-temporary-password" };
const _hoisted_2 = { class: "login-temporary-password__header" };
const _hoisted_3 = ["onSubmit"];
const _hoisted_4 = { class: "login-temporary-password__form-group" };
const _hoisted_5 = {
    class: "login-temporary-password__label",
    for: "temporary-password"
};
const _hoisted_6 = { class: "login-temporary-password__hint" };
const _hoisted_7 = { class: "login-temporary-password__footer" };
const _hoisted_8 = ["onClick"];
import LoginFormLogo from '@/components/login/_atoms/LoginFormLogo.vue';
import i18n from '@/i18n';
import { computed, reactive, ref } from 'vue';
import { useToast } from 'vue-toastification';
import { validateTemporaryPassword } from '../data/validateTemporaryPassword';
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoginTemporaryPassword',
    props: {
        email: { default: '' }
    },
    emits: ['temporary-password-validated', 'forgot-password'],
    setup(__props, { emit }) {
        const props = __props;
        const toastOptions = {
            timeout: 6000,
        };
        const { t } = i18n.global;
        const toast = useToast();
        const loading = ref(false);
        const formData = reactive({ temporaryPassword: '' });
        const isFormValid = computed(() => {
            return formData.temporaryPassword.length > 0;
        });
        const validate = async () => {
            if (!isFormValid.value)
                return;
            loading.value = true;
            try {
                const response = await validateTemporaryPassword(props.email, formData.temporaryPassword);
                if (!response.success) {
                    loading.value = false;
                    toast.error(t('first-access-password.temporary.toast.error'), toastOptions);
                    return;
                }
                loading.value = false;
                emit('temporary-password-validated');
            }
            catch (error) {
                loading.value = false;
                toast.error(t('first-access-password.temporary.toast.error'), toastOptions);
            }
        };
        const handleForgotPassword = () => {
            emit('forgot-password');
        };
        return (_ctx, _cache) => {
            const _component_el_input = _resolveComponent("el-input");
            const _component_el_button = _resolveComponent("el-button");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(LoginFormLogo)
                ]),
                _createElementVNode("form", {
                    class: "login-temporary-password__form",
                    onSubmit: _withModifiers(validate, ["prevent"])
                }, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('first-access-password.temporary.password-label')), 1),
                        _createVNode(_component_el_input, {
                            id: "temporary-password",
                            modelValue: formData.temporaryPassword,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.temporaryPassword) = $event)),
                            type: "password",
                            placeholder: _ctx.$t('first-access-password.temporary.password-placeholder'),
                            "show-password": ""
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createElementVNode("small", _hoisted_6, _toDisplayString(_ctx.$t('first-access-password.temporary.password-hint')), 1)
                    ]),
                    _createVNode(_component_el_button, {
                        class: "login-temporary-password__button",
                        "native-type": "submit",
                        disabled: !isFormValid.value,
                        loading: loading.value
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('first-access-password.temporary.submit-button')), 1)
                        ]),
                        _: 1
                    }, 8, ["disabled", "loading"]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("a", {
                            class: "login-temporary-password__link",
                            href: "#",
                            onClick: _withModifiers(handleForgotPassword, ["prevent"])
                        }, _toDisplayString(_ctx.$t('first-access-password.temporary.forgot-password')), 9, _hoisted_8)
                    ])
                ], 40, _hoisted_3)
            ]));
        };
    }
});
